export interface LayerDef {
  name: string;
  url: string;
  attribution: string;
  subdomains?: string[];
  checked?: boolean;
}

export const googleAttribution = "&copy; Google Maps &copy;";
export const googleHybridView =
  "http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}&lang=en";

export const googleStreetView =
  "http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&lang=en";

export const googleSubdomains = ["mt0", "mt1", "mt2", "mt3"];

export const layerDef: LayerDef[] = [
  {
    name: "Hybrid View",
    url: googleHybridView,
    attribution: googleAttribution,
    subdomains: googleSubdomains,
    checked: true,
  },
  {
    name: "Street View",
    url: googleStreetView,
    attribution: googleAttribution,
    subdomains: googleSubdomains,
  },
];
